import type { ComponentProps } from 'react'

import {
  ICON_DEFAULT_COLOR,
  ICON_DEFAULT_FILL,
  ICON_DEFAULT_HEIGHT,
  ICON_DEFAULT_VIEWBOX,
  ICON_DEFAULT_WIDTH,
  type IconProps,
} from 'components'

export const Pencil = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = ICON_DEFAULT_WIDTH,
  height = ICON_DEFAULT_HEIGHT,
  viewBox = ICON_DEFAULT_VIEWBOX,
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      fill={fill}
      height={height}
      viewBox={viewBox}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M 44.269531 10.039062 C 44.269531 8.894531 43.816406 7.800781 43.007812 6.992188 C 42.199219 6.183594 41.105469 5.730469 39.960938 5.726562 C 38.820312 5.726562 37.71875 6.179688 36.910156 6.988281 L 36.914062 6.988281 L 33.472656 10.429688 L 39.570312 16.527344 L 43.007812 13.085938 L 43.292969 12.769531 C 43.921875 12.003906 44.269531 11.039062 44.269531 10.039062 Z M 9.109375 34.800781 C 8.808594 35.101562 8.582031 35.472656 8.457031 35.878906 L 5.988281 44.007812 L 14.121094 41.542969 L 14.421875 41.433594 C 14.710938 41.304688 14.976562 41.121094 15.203125 40.894531 L 37.359375 18.734375 L 31.265625 12.640625 Z M 47.394531 10.039062 C 47.394531 11.886719 46.707031 13.667969 45.472656 15.03125 L 45.214844 15.296875 L 40.839844 19.671875 C 40.792969 19.734375 40.746094 19.796875 40.6875 19.855469 C 40.628906 19.914062 40.566406 19.964844 40.5 20.011719 L 17.410156 43.109375 C 16.828125 43.6875 16.128906 44.136719 15.363281 44.421875 L 15.03125 44.53125 L 5.960938 47.28125 L 5.957031 47.28125 C 5.507812 47.417969 5.027344 47.429688 4.574219 47.316406 C 4.117188 47.199219 3.703125 46.964844 3.367188 46.632812 C 3.035156 46.300781 2.796875 45.886719 2.683594 45.429688 C 2.566406 44.972656 2.578125 44.496094 2.714844 44.042969 L 2.714844 44.039062 L 5.464844 34.96875 L 5.46875 34.964844 L 5.582031 34.632812 C 5.871094 33.867188 6.320312 33.171875 6.902344 32.589844 L 29.992188 9.488281 C 30.035156 9.429688 30.089844 9.367188 30.144531 9.3125 C 30.199219 9.253906 30.261719 9.207031 30.320312 9.160156 L 34.703125 4.78125 L 34.972656 4.527344 C 36.335938 3.292969 38.113281 2.601562 39.960938 2.601562 C 41.933594 2.605469 43.824219 3.386719 45.21875 4.78125 C 46.613281 6.175781 47.394531 8.066406 47.394531 10.039062 Z M 47.394531 10.039062 "
        fill={color}
      />
    </svg>
  )
}
